module.exports = __webpack_public_path__ + "static/media/watertank.4f91053a.png";